export default "__VITE_ASSET__BgOEldDj__"